import React, { useContext, useState } from "react";
import './ProductDisplay.css';
import whatsapp from "../assets/logo/whatsapp.png";
import { Link } from "react-router-dom";
import { ShopContext } from "../../context/ShopContext";
import { formatPrice } from "../../utils/formatPrice";
import StarRating from "./StarRating";

// Tailoring / sweet / semi-sweet / snack products: flat new_price/old_price,
// no variant configurator (no egg/eggless, format, weight, sheet, or layers).
const GenericProductPage = (props) => {
    const { product, averageRating = 0, reviewCount = 0 } = props;
    const { addToCart } = useContext(ShopContext);

    const isStartingPrice = product.category === "tailoring";
    const isContactOnly = product.subCategory === "alteration" || product.subCategory === "saree-threading" || product.subCategory === "blouse";
    const connectMessage = encodeURIComponent(`Connect~${product.name}`);

    const images = product.images && product.images.length > 0 ? product.images : [product.image];
    const [mainImage, setMainImage] = useState(images[0]);

    return (
        <>
            <div className="productdisplay w-full">

                <div className="productdisplay-left">
                    <div className="productdisplay-img-list">
                        {images.map((img, i) => (
                            <img
                                key={i}
                                src={img}
                                alt=""
                                className="productdisplay-thumb-img"
                                style={{ cursor: "pointer", border: img === mainImage ? "2px solid #f4511e" : undefined }}
                                onClick={() => setMainImage(img)}
                            />
                        ))}
                    </div>
                    <div className="productdisplay-img">
                        <img src={mainImage} alt="" className="productdisplay-main-img" />
                    </div>
                </div>

                <div className="productdisplay-right">
                    <span className="product-name">{product.name}</span>
                    <div className="productdisplay-right-star">
                        <StarRating rating={averageRating} />
                        <p>({reviewCount})</p>
                    </div>
                    <div className="productdisplay-right-prices">
                        {product.old_price && (
                            <div className="productdisplay-right-price-old">{formatPrice(product.old_price)}</div>
                        )}
                        <div className="productdisplay-right-price-new">
                            {isStartingPrice && "Starting at "}{formatPrice(product.new_price)}
                        </div>
                    </div>
                    {product.note && <p className="productdisplay-note">{product.note}</p>}

                    {isContactOnly ? (
                        <Link
                            to={"https://wa.me/14249778995?text=" + connectMessage}
                            className="whatsapp-cta"
                        >
                            <span>Connect</span>
                            <img src={whatsapp} alt="" width="30px" height="" />
                        </Link>
                    ) : (
                        <button onClick={() => { addToCart(product, null) }} >ADD TO CART</button>
                    )}
                    <p className="productdisplay-right-category"><span>Category: </span>{product.category}</p>
                </div>

            </div >
        </>
    )
}

export default GenericProductPage;
